export default "__VITE_ASSET__beceabb6__"